export const ELEMENT_TEST_IDS = {
    MODAL_TID: {
        CANCEL_BTN: 'modal-cancel-btn',
        CONFIRM_BTN: 'modal-confirm-btn',
        RESET_BTN: 'modal-reset-btn',
        CLOSE_BTN: 'modal-close-btn',
    }

}